import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { BrMaskDirective } from './br-mask.directive';

/**
 * Drop-in replacement for `BrMaskerModule` from the unmaintained `br-mask`
 * package. See `./br-mask.directive.ts` for details.
 */
@NgModule({
  declarations: [BrMaskDirective],
  exports: [BrMaskDirective],
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BrMaskerModule {}

export { BrMaskDirective, BrMaskModel } from './br-mask.directive';
